export enum CustomEvents {
  VIDEO_STARTED_PLAYING = 'dcw-video-started-playing',
  VIDEO_GOT_PAUSED = 'dcw-video-got-paused',
  ICON_ANIMATION_FINISHED = 'icon-animation-finished',
  CHANGE_SLIDE = 'change-slide',
  CHANGE_FILTERS = 'dcw-change-filters',
  CHANGE_VARIANT = 'dcw-change-variant'
}
